<template>
    <div class="scc-container">
        <div v-if="sectionTitle !== ''" class="scc-container__row">
            <div class="scc-container__column scc-container__column--12">
                <Heading tag="h2" class="h1" margin="x-large" :title="sectionTitle"></Heading>
            </div>
        </div>
        <div class="scc-container__row">
            <div class="scc-container__column scc-container__column-lg--12">
                <div
                    class="scc-image-with-text-box"
                    :class="[
                        reversePosition ? 'scc-image-with-text-box--reversed' : null,
                        `scc-image-with-text-box--${backgroundColor}`,
                    ]"
                >
                    <div
                        class="scc-image-with-text-box__left-container scc-container__column"
                        :class="columns ? `scc-container__lg-column--${columns}` : null"
                        :style="[backgroundImage]"
                    >
                        <div class="scc-image-with-text-box__accent-shape"></div>
                    </div>
                    <div
                        class="scc-image-with-text-box__right-container"
                        :class="columns ? `scc-container__lg-column--${12 - columns}` : null"
                    >
                        <h3 class="scc-image-with-text-box__title h4">{{ title }}</h3>
                        <p class="scc-image-with-text-box__subtitles bold">
                            <template v-for="(text, i) in formattedSubtitle">
                                <span :key="'text-' + i" class="scc-image-with-text-box__subtitle">{{ text }}</span>
                                <div
                                    v-if="i < formattedSubtitle.length - 1"
                                    :key="'icon-' + i"
                                    class="scc-image-with-text-box__icon"
                                    :class="{ 'scc-image-with-text-box__icon--no-margin-left': text === '' }"
                                ></div>
                            </template>
                        </p>
                        <p class="scc-image-with-text-box__text">{{ text }}</p>
                        <SccLink
                            class="scc-image-with-text-box__button"
                            button
                            large
                            inverted
                            :color="backgroundColor"
                            :to="buttonLinkTo"
                        >
                            {{ buttonText }}
                        </SccLink>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './image-with-text-box.scss';
import SccLink from '../global/SccLink';
import Heading from './Heading';

export default {
    name: 'ImageWithTextBox',
    components: { SccLink, Heading },
    __editor: {
        fields: {
            image: {
                widget: 'media',
            },
            backgroundColor: {
                widget: 'select',
                values: ['primary', 'secondary'],
            },
        },
    },
    props: {
        reversePosition: {
            type: Boolean,
            default: false,
        },
        columns: {
            type: Number,
            default: 6,
        },
        image: String,
        sectionTitle: {
            type: String,
            default: 'Lorem ipsum dolor sit amet consecetur',
        },
        title: {
            type: String,
            default: 'Lorem ipsum dolor sit amet consecetur',
        },
        subtitle: {
            type: String,
            default: 'Lorem ipsum',
        },
        text: {
            type: String,
            default:
                'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est. Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea.',
        },
        buttonText: {
            type: String,
            default: 'Speel mee',
        },
        buttonLinkTo: {
            type: String,
            default: 'aanmelden',
        },
        backgroundColor: {
            type: String,
            default: 'primary',
            required: false,
            validator: function(val) {
                return ['primary', 'secondary'].includes(val);
            },
        },
    },
    computed: {
        backgroundImage() {
            return {
                backgroundImage: `url(${this.image})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            };
        },
        formattedSubtitle() {
            return this.subtitle.split('/');
        },
    },
};
</script>
